import { FC, useEffect, useState } from "react";

import { useWallet } from "hooks";

import { RoundConfig } from "models";
import { Booster, Loader } from "components";
import { ROUNDS } from "config";
import { useRounds } from "hooks/query";
import infoIcon from "assets/risk/info.svg";
import { RoundList } from "./components";

import styles from "./Investing.module.scss";

const Investing: FC = () => {
  const { networkId, activeNetwork } = useWallet();
  const isAvailableNetwork = networkId === activeNetwork.networkId;

  const [configs, setConfigs] = useState<RoundConfig[]>([]);

  useEffect(() => {
    if (networkId === activeNetwork.networkId) {
      const roundsByNetworkId = ROUNDS.filter(
        (roundConfig) => roundConfig.networkId === activeNetwork.networkId
      );
      setConfigs(roundsByNetworkId);
    } else {
      setConfigs([]);
    }
  }, [networkId, activeNetwork]);

  const { isLoading, rounds } = useRounds(configs);

  if (isLoading) {
    return <Loader />;
  }

  const content = (
    <div className={styles.popupWrapper}>
      <div>
        <img src={infoIcon} alt="Info" />
      </div>
      <div className={styles.contentWrapper}>
        <div>
          <span>
            Boosters allow you to get a higher allocation in the UFI round by
            applying early. The earlier you apply, the greater booster you get
          </span>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className={styles.container}>
        <h1 className={styles.title}>Investment Round</h1>
        {rounds[0]?.booster && (
          <Booster overlayClassName={styles.popover} blink>
            {{
              content,
              left: <>Today&apos;s allocation booster</>,
              right: <b>x{rounds[0]?.booster}</b>,
            }}
          </Booster>
        )}
      </div>
      {isAvailableNetwork && <RoundList rounds={rounds} />}
    </>
  );
};

export default Investing;
